import CashbackIcon from "@/src/common/icons/CashbackIcon";
import * as stylex from "@stylexjs/stylex";

import type { PropsWithStyleX, QueryXsMax } from "../../styles/tokens.stylex";
import { colors } from "../../styles/tokens.stylex";
import type { ISpecialCashback } from "./CashbackCommonInterfaces";

export interface ICashbackLabel extends PropsWithStyleX {
    value?: string;
    specialCashback?: ISpecialCashback;
}

export default function CashbackLabel({ specialCashback, value, styleX }: ICashbackLabel) {
    if (!value) {
        return null;
    }

    return (
        <div {...stylex.props(styles.cashbackLabelComponent, styleX)}>
            <span {...stylex.props(styles.svgContainer)}>
                <CashbackIcon />
            </span>
            <div {...stylex.props(styles.cashbackValues)}>
                {specialCashback ? (
                    <>
                        <b>{specialCashback.maxCashback}</b>
                        {specialCashback?.overrideSegmentMaxCashback && (
                            <span {...stylex.props(styles.oldValue)}>{value}</span>
                        )}
                    </>
                ) : (
                    <p {...stylex.props(styles.pTag)} aria-label={`${value} cashback`}>
                        {value}
                    </p>
                )}
            </div>
        </div>
    );
}

const xsMax: QueryXsMax = "@media (max-width: 759px)";

const styles = stylex.create({
    cashbackLabelComponent: {
        alignItems: "center",
        display: "inline-flex",
        fontSize: "0.875rem",
    },

    svgContainer: {
        zIndex: 1,
        height: { default: "30px", [xsMax]: "22px" },
        width: { default: "30px", [xsMax]: "22px" },
    },

    cashbackValues: {
        borderRadius: "12.6px",
        backgroundColor: colors.fg_BrandNavy,
        color: "#fff",
        lineHeight: 1.1,
        marginLeft: "-20px",
        paddingBottom: "0.2em",
        paddingLeft: "25px",
        paddingRight: "10px",
        paddingTop: "0.2em",
    },

    pTag: {
        paddingBlock: "0.2em",
        paddingInline: "0",
    },

    oldValue: {
        textDecoration: "line-through",
        marginLeft: "5px",
    },
});
